<template>
  <div
    class="stat-badge"
    :class="[`stat-badge--${variant}`, `stat-badge--${size}`]"
    v-b-tooltip.hover
    :title="tooltip"
  >
    {{ label }}<span class="stat-badge-value">{{ value }}</span>
  </div>
</template>

<script>
/**
 * StatBadge
 *
 * Caixinha colorida com um label curto em cima/ao lado e um valor em
 * destaque embaixo — o padrão repetido nas colunas de estatísticas de
 * tabelas do tipo `CardTable` (ex.: Notificações, Avaliações). Genérico:
 * não conhece o domínio de quem o usa, só recebe label/valor/cor.
 */
export default {
  name: "StatBadge",

  props: {
    /** Texto curto exibido acima do valor (ex.: "Total", "Pend."). */
    label: {
      type: String,
      required: true,
    },
    /** Valor em destaque (número ou "—" para ausência de dado). */
    value: {
      type: [String, Number],
      default: "—",
    },
    /** Cor de fundo do badge, mapeada para as variáveis do projeto. */
    variant: {
      type: String,
      default: "blue",
      validator: (value) =>
        ["blue", "purple", "yellow", "green", "orange"].includes(value),
    },
    /** Tamanho do badge — "md" (padrão) ou "sm" para grupos mais densos. */
    size: {
      type: String,
      default: "md",
      validator: (value) => ["sm", "md"].includes(value),
    },
    /** Texto do tooltip exibido ao passar o mouse (opcional). */
    tooltip: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables.scss";

.stat-badge {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: $white;
  font-weight: 600;
  line-height: 1.3;
  flex: 1 1 0;
  min-width: 0;
}

.stat-badge-value {
  font-weight: 800;
}

.stat-badge--md {
  padding: 6px 12px;
  min-width: 56px;
  font-size: 12px;

  .stat-badge-value {
    font-size: 16px;
    margin-top: 2px;
  }
}

.stat-badge--sm {
  padding: 4px 10px;
  min-width: 44px;
  font-size: 11px;

  .stat-badge-value {
    font-size: 14px;
    margin-top: 1px;
  }
}

.stat-badge--blue {
  background: $blue;
}

.stat-badge--purple {
  background: $purple;
}

.stat-badge--yellow {
  background: $yellow;
  color: $grey1;
}

.stat-badge--green {
  background: $green1;
}

.stat-badge--orange {
  background: $orange;
}
</style>
